import React from "react"

import { urlSchema } from "@/schemas"
import { getDisplayValue } from "@/utils/value"

import { Link as MuiLink } from "@mui/material"

interface CredentialWebsiteLinkProps {
  website: string | null | undefined
}

export const CredentialWebsiteLink: React.FC<CredentialWebsiteLinkProps> = ({
  website,
}) => {
  if (typeof website === "string") {
    const parsedWebsite = urlSchema.safeParse(website)

    if (parsedWebsite.success) {
      return (
        <MuiLink
          href={parsedWebsite.data}
          rel="noopener noreferrer"
          target="_blank"
          underline="hover"
        >
          {parsedWebsite.data}
        </MuiLink>
      )
    }
  }

  return getDisplayValue(website)
}
